export const FETCH_NEW_COURSE_ITEM = 'FETCH_NEW_COURSE_ITEM'
export const FETCH_NEW_COURSE_ITEM_SUCCESS = 'FETCH_NEW_COURSE_ITEM_SUCCESS'
export const FETCH_NEW_COURSE_ITEM_FAILURE = 'FETCH_NEW_COURSE_ITEM_FAILURE'
export const FETCH_NEW_COURSE_ITEM_CANCEL = 'FETCH_NEW_COURSE_ITEM_CANCEL'
